export const initializeThemeMode = () => {
    document.documentElement.classList.toggle('dark', isDarkMode());
};

export const turnLightMode = () => {
    window.localStorage.setItem('theme', 'light');
    initializeThemeMode();
};

export const turnDarkMode = () => {
    window.localStorage.setItem('theme', 'dark');
    initializeThemeMode();
};

export const turnSystemMode = () => {
    window.localStorage.removeItem('theme');
    initializeThemeMode();
};

export const isDarkMode = () => {
    const themeFromLocalStorage = window.localStorage.getItem('theme');

    return (
        themeFromLocalStorage === 'dark' ||
        (!themeFromLocalStorage && window.matchMedia('(prefers-color-scheme: dark)').matches)
    );
};
